module.exports = __webpack_public_path__ + "static/media/fly0263.010c54bc.webp";